export default __webpack_public_path__ + "static/B0027-8ae8d0f26a012c66dbd2e162f34d1fbd.png";